import React, { useEffect, useState } from "react";

const AdminUsersPage = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [updatingUserId, setUpdatingUserId] = useState(null);
  const token = localStorage.getItem("auth_token");

  useEffect(() => {
    fetch("https://loopsneller.com/api/admin/users", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setUsers(data);
        setLoading(false);
      });
  }, [token]);

  const handleRoleChange = async (userId, newRole) => {
    setUpdatingUserId(userId);

    try {
      const res = await fetch(
        `https://loopsneller.com/api/admin/users/${userId}/role`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ role: newRole }),
        }
      );

      const data = await res.json();
      if (data.user) {
        setUsers((prev) =>
          prev.map((user) =>
            user.id === userId ? { ...user, role: data.user.role } : user
          )
        );
      }
    } catch (err) {
      console.error("Failed to update role", err);
    } finally {
      setUpdatingUserId(null);
    }
  };

  if (loading) return <div className="text-center mt-5">Loading users...</div>;

  return (
    <div className="container mt-5">
      <h2 className="mb-4">All Users</h2>
      <div className="table-responsive">
        <table className="table table-striped align-middle">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>System Role</th>
              <th>Projects & Project Roles</th>
              <th>Change Role</th>
            </tr>
          </thead>
          <tbody>
            {users.map((user) => (
              <tr key={user.id}>
                <td>{user.name}</td>
                <td>{user.email}</td>
                <td>
                  <span className="badge bg-secondary">{user.role}</span>
                </td>
                <td>
                  {user.projects.length > 0 ? (
                    <ul className="mb-0">
                      {user.projects.map((project) => (
                        <li key={project.id}>
                          {project.name} –{" "}
                          <span className="badge bg-info text-dark">
                            {project.pivot.role}
                          </span>
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <em>No projects</em>
                  )}
                </td>
                <td>
                  <select
                    className="form-select"
                    value={user.role}
                    disabled={updatingUserId === user.id}
                    onChange={(e) => handleRoleChange(user.id, e.target.value)}
                  >
                    <option value="Employee">Employee</option>
                    <option value="Manager">Manager</option>
                    <option value="Admin">Admin</option>
                  </select>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminUsersPage;
